import request from './request';
export function search(params) {
  return request.get('/api/search/search', { params });
}
export function hotSearch() {
  return request.get('/api/search/hotSearch');
}
